import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({

  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff',
      '& *': {
        stroke: '#fff'
      }
    }
  },

}));
